<template>
  <div class="content-item mb8 clearFloat">
    <cx-border
      :borderWidth.sync="borderWidth"
      :borderStyle.sync="borderStyle"
      :borderColor.sync="borderColor"
      :borderIsThemeColor.sync="borderIsThemeColor"
      :activeNameColor.sync="borderActiveNameColor"
      :showGradientBorder="true"
      :options="options"
    />
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      borderShadowChecked: true,
      borderTypeFlag: 1,
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("../../../../assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("../../../../assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("../../../../assets/images/dotted-1.png")
        }
      ]
    }
  },
  computed: {
    showBorder: {
      get() {
        return this.borderWidth !== 0
      },
      set(val) {
        if (val) {
          this.$emit("update", "borderWidth", 2)
        } else {
          this.$emit("update", "borderWidth", 0)
        }
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        if (newVal === this.borderStyle) return
        this.$emit("update", "borderStyle", newVal)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        if (newVal === this.borderColor) return
        this.$emit("update", "borderColor", newVal)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        if (newVal === this.borderWidth) return
        this.$emit("update", "borderWidth", newVal)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor ? this.options.borderIsThemeColor:false
      },
      set(newVal) {
        if (newVal === this.borderIsThemeColor) return
        this.$emit("update", "borderIsThemeColor", newVal)
      }
    },
    borderActiveNameColor: {
      get() {
        return this.options.borderActiveNameColor
      },
      set(newVal) {
        this.$emit("update", "borderActiveNameColor", newVal)
      }
    }
  },
  methods: {
    changeBorderSelection() {
      if (
        this.borderStyleList.filter(borderStyle => {
          return borderStyle.value == this.borderStyle
        }).length > 0
      ) {
        let path = this.borderStyleList.filter(borderStyle => {
          return borderStyle.value == this.borderStyle
        })[0].src
        this.$refs.borderStyleSelect.$el.children[0].children[0].setAttribute(
          "style",
          "background-image:url(" +
            path +
            ")!important;color:#fff0;background-repeat: no-repeat;background-size:86% auto;background-position: left center"
        )
      }
    },
    checkboxHandle() {
      this.borderColor = "#FFFFFF"
      this.borderWidth = 1
      this.borderStyle = "solid"
      this.changeBorderSelection()
    }
  }
}
</script>

<style scoped>
.icon-portal-full-screen1.select::before {
  color: #ffffff;
}
.icon-portal-adjustment1.select::before {
  color: #ffffff;
}
.border-image {
  width: 200px;
}
.scale-radio-group/deep/ .el-radio__label {
  margin-left: 0;
}
</style>
